import teamMember from "../../img/homepage/team-member.png";
import resourceAllocation from "../../img/homepage/resource-allocation.png";
import projectManager from "../../img/homepage/project-manager.png";
import teamManager from "../../img/homepage/team-manager.png";
import workspaceAdmin from "../../img/homepage/workspace-admin.png";

import curated01 from "../../img/homepage/curated-01.png";
import curated02 from "../../img/homepage/curated-02.png";
import curated03 from "../../img/homepage/curated-03.png";
import curated04 from "../../img/homepage/curated-04.png";
import curated05 from "../../img/homepage/curated-05.png";
import curated06 from "../../img/homepage/curated-06.png";

import monitor from "../../img/svg/monitor.svg";
import playButton from "../../img/svg/play-button.svg";
import videoCamera from "../../img/svg/video-camera.svg";
import teacher from "../../img/svg/teacher.svg";
import lightbulb from "../../img/svg/lightbulb.svg";

export default function injectHomePage() {
  // ----------------------------- //
  // handle navbar class on scroll //
  // ----------------------------- //
  let navbar = document.querySelector("#header");
  document.addEventListener("scroll", () => {
    if (window.scrollY > 600) {
      navbar.classList.add("scrolled");
    } else {
      navbar.classList.remove("scrolled");
    }
  });

  // ----------------------------------- //
  // Add sections under home page header //
  // ----------------------------------- //
  let catalogContent = document.querySelector("#catalog-content");

  // "Start Learning!" section
  let subHeroSection = document.createElement("div");
  subHeroSection.classList.add("subhero-section");
  subHeroSection.innerHTML = `
    <h2>Start Learning!</h2>
    <p>Choose the onboarding path relevant to your role and begin your journey to become more productive with ClickUp.</p>
    <p>Want to see all of our courses? Browse the <a href="page/course-catalog">All Courses page</a>!</p>
  `;

  let subHeroButtonData = [
    {
      color: "#B6ACF6",
      pic: teamMember,
      text: "Getting Started",
      url: "/path/clickup-for-beginners",
    },
    {
      color: "#AAA0F4",
      pic: resourceAllocation,
      text: "Build Your First Workflow",
      url: "/path/build-your-first-workflow",
    },
    {
      color: "#A395F3",
      pic: projectManager,
      text: "Become a ClickUp Expert",
      url: "/path/become-a-clickup-expert",
    },
    {
      color: "#8F7FF1",
      pic: teamManager,
      text: "Get Advanced AI Skills",
      url: "/path/clickup-advanced-ai-skills",
    },
    {
      color: "#7B68EE",
      pic: workspaceAdmin,
      text: "Workspace Admin",
      url: "/path/new-workspace-admin",
    },
  ];

  let subHeroButtons = document.createElement("div");
  subHeroButtons.classList.add("subhero-buttons");

  for (let btn of subHeroButtonData) {
    let subHeroButton = document.createElement("a");
    subHeroButton.classList.add("subhero-button");
    subHeroButton.href = btn.url;
    subHeroButton.style.backgroundColor = btn.color;
    subHeroButton.innerHTML = `
            <img class="subhero-button-img" src="${btn.pic}">
            <p class="subhero-button-text">${btn.text}</p>
        `;

    subHeroButtons.append(subHeroButton);
  }

  subHeroSection.append(subHeroButtons);
  catalogContent.before(subHeroSection);

  // "What do you want to do?" section
  let curatedContentSection = document.createElement("div");
  curatedContentSection.classList.add("curated-content-section");
  curatedContentSection.innerHTML = `
        <h2>What do you want to do?</h2>
        <p>Check out curated content to help you meet your productivity goals with ClickUp</p>
        <p>Want to see all of our courses? Browse the <a href="page/course-catalog">All Courses page</a>!</p>
    `;

  let curatedContentData = [
    {
      pic: curated02,
      text: "What’s new?",
      url: "/page/course-catalog#hot-off-the-press_explore-whats-new",
    },
    {
      pic: curated04,
      text: "Live Workshops",
      url: "/page/live-training",
    },
    {
      pic: curated05,
      text: "Earn Your ClickUp Certificate",
      url: "/page/clickup-certificates-page",
    },
    {
      pic: curated03,
      text: "Sharpen Project Management Skills",
      url: "/page/course-catalog#learning-objectives_project-management",
    },
    {
      pic: curated06,
      text: "Save Time With Productivity Best Practices",
      url: "/page/course-catalog#learning-objectives_productivity-best-practices",
    },
    {
      pic: curated01,
      text: "New ClickUp Features",
      url: "/path/whats-new-in-clickup-3-0",
    },
  ];

  let curatedContentCards = document.createElement("div");
  curatedContentCards.classList.add("curated-content-cards");

  for (let card of curatedContentData) {
    let curatedContentCard = document.createElement("a");
    curatedContentCard.classList.add("curated-content-card");
    curatedContentCard.href = card.url;
    curatedContentCard.innerHTML = `
            <img class="curated-content-img" src="${card.pic}">
            <p class="curated-content-text">${card.text}</p>
        `;

    curatedContentCards.append(curatedContentCard);
  }

  curatedContentSection.append(curatedContentCards);
  catalogContent.before(curatedContentSection);

  // "How do you want to learn?" section
  let learnSection = document.createElement("div");
  learnSection.classList.add("learn-section");
  learnSection.innerHTML = `
        <h2>How do you want to learn?</h2>
        <p>Choose your favorite mode of learning</p>
    `;

  let learnButtonData = [
    // {
    //   icon: monitor,
    //   text: "Live Training",
    //   url: "/page/course-catalog#learning-style_live-training",
    // },
    {
      icon: playButton,
      text: "On-Demand Webinar",
      url: "/page/webinars",
    },
    {
      icon: videoCamera,
      text: "Video Course",
      url: "/page/course-catalog#learning-style_video-course",
    },
    {
      icon: teacher,
      text: "Self-Paced Course",
      url: "/page/course-catalog#learning-style_self-paced-course",
    },
    // {
    //   icon: lightbulb,
    //   text: "ClickTips and Tricks",
    //   url: "/page/course-catalog#learning-style_clicktips-tricks",
    // },
  ];

  let learnButtons = document.createElement("div");
  learnButtons.classList.add("learn-buttons");

  for (let btn of learnButtonData) {
    let learnButton = document.createElement("a");
    learnButton.classList.add("learn-button");
    learnButton.href = btn.url;
    learnButton.innerHTML = `
            <div class="learn-button-icon-container">
                <img class="learn-button-icon" src="${btn.icon}">
            </div>
            <p class="learn-button-text">${btn.text}</p>
        `;

    learnButtons.append(learnButton);
  }

  learnSection.append(learnButtons);
  catalogContent.before(learnSection);

  // ------------------------------------------ //
  // update button text on search results cards //
  // ------------------------------------------ //
  let pathCardBtns = document.querySelectorAll(".course-series-count");
  for (let btn of pathCardBtns) {
    btn.innerHTML = "View";
  }

  // ------------------------------- //
  // add course cards section header //
  // ------------------------------- //
  let homePageCourses = document.querySelector("#catalog-courses");

  let learningPathsDescription = document.createElement("div");
  learningPathsDescription.id = "learning-paths-description";
  learningPathsDescription.innerHTML = `
        <p>Check out content relevant to your role, or pursue paths to help you master ClickUp and become more productive.</p>
        <p>Want to see all of our courses? Browse the <a href="page/course-catalog">All Courses page</a>!</p>
    `;

  homePageCourses.prepend(learningPathsDescription);

  // ------------------------------------------------------- //
  // attach styles to landing page cards, based on data tags //
  // ------------------------------------------------------- //
  let homePageCards = document.querySelectorAll("a.coursebox-container.course");
  for (let card of homePageCards) {
    for (let tag of card.attributes["data-tags"].value.split(",")) {
      card.classList.add("tag-" + tag);
    }
  }

  // -------------------------------------------- //
  // add extra sections to the bottom of the page //
  // -------------------------------------------- //
  let homePageContent = document.querySelector("#skilljar-content");

  let extraSections = document.createElement("div");
  extraSections.id = "extra-sections";

  // certificates banner
  // let certificatesBanner = document.createElement("div");
  // certificatesBanner.id = "certificates-banner";
  // certificatesBanner.classList.add("extra-section");
  // certificatesBanner.innerHTML = `
  //       <div class="certificates-banner-content">
  //           <p>
  //               Show off your ClickUp skills with certificates. <a href="page/clickup-certificates-page">Learn More</a>
  //           </p>
  //           <div class="all-badges">
  //               <a href="/path/clickup-for-beginners?reg=1"><img src="https://cu-university-static-staging.web.clickup.com/img/digital-badges/cuu-novice-badge-sm.png"></a>
  //               <a href="/path/become-a-clickup-expert"><img src="https://cu-university-static-staging.web.clickup.com/img/digital-badges/cuu-expert-badge-sm.png"></a>
  //               <a href="/path/clickup-admin-certificate-prep"><img src="https://cu-university-static-staging.web.clickup.com/img/digital-badges/cuu-admin-badge-sm.png"></a>
  //               <a href="/path/clickup-advanced-ai-skills"><img src="https://cu-university-static-staging.web.clickup.com/img/digital-badges/cuu-advanced-ai-skills-badge-sm.png"></a>
  //           </div>
  //       </div>
  //   `;

  // all courses button container
  let allCoursesContainer = document.createElement("div");
  allCoursesContainer.id = "all-courses-container";
  allCoursesContainer.classList.add("extra-section");
  allCoursesContainer.innerHTML = `
        <a href="/page/course-catalog">
            <h2>Browse All Courses</h2>
        </a>
        <h3>Check out our new courses and much more!</h3>
    `;

  let ctaButton = document.createElement("A");
  ctaButton.id = "all-courses-button";
  ctaButton.href = "page/course-catalog";
  ctaButton.innerText = "View All Courses";

  allCoursesContainer.append(ctaButton);

  // extraSections.append(certificatesBanner);
  extraSections.append(allCoursesContainer);

  homePageContent.append(extraSections);
}
